import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface WebsiteVolunteerRequest {
  id: string;
  name: string;
  email: string;
  subject?: string | null;
  message?: string | null;
  created_at?: string;
}

export const useWebsiteVolunteerRequests = () => {
  return useQuery<WebsiteVolunteerRequest[]>({
    queryKey: ['websiteVolunteerRequests'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_volunteer_requests')
        .select('id, name, email, subject, message, created_at')
        .order('created_at', { ascending: false })
        .limit(500);
      if (error) throw error;
      return (data as WebsiteVolunteerRequest[]) ?? [];
    },
    staleTime: 60_000,
  });
};
